import React, { useMemo } from "react";
import { DateRangePickerPreset, DatePickerRange } from "./DateRangePicker";
import { Dropdown } from "./Dropdown";

type DateRangePresetsDropdownProps = {
  value: DatePickerRange | undefined;
  title?: string;
  presetDateRanges: DateRangePickerPreset[];
  onSelect: (dateRange: DatePickerRange) => void;
};

export function DateRangePresetsDropdown({
  value,
  title,
  presetDateRanges,
  onSelect,
}: DateRangePresetsDropdownProps) {
  const selectedPresetKey = useMemo(() => {
    if (value === undefined) {
      return undefined;
    }

    return presetDateRanges.find(
      (preset) =>
        value.from.getTime() === preset.dateRange.from.getTime() &&
        value.to.getTime() === preset.dateRange.to.getTime(),
    )?.key;
  }, [value, presetDateRanges]);

  const options = presetDateRanges.map((preset) => ({
    value: preset.key,
    label: preset.label,
  }));

  return (
    <Dropdown
      placeholder={title}
      value={selectedPresetKey}
      variant="outline"
      ariaLabel={title}
      options={options}
      onChange={(presetKey) => {
        const preset = presetDateRanges.find((item) => item.key === presetKey);
        if (preset) {
          onSelect(preset.dateRange);
        }
      }}
    />
  );
}
